// extracted by mini-css-extract-plugin
module.exports = {"methods":"PaymentMethodTitle_methods_2ow9o"};